module.exports = __webpack_public_path__ + "static/media/gift.1284f9aa.svg";